import {defineStore} from 'pinia'
import {shallowRef, computed} from 'vue'
import {useSessionStore} from 'shared/stores/session'

export const useSessionEventsStore = defineStore('sessionEvents', () => {
	const sessionStore = useSessionStore()

	const rawEvents = shallowRef()

	const processedEvents = computed(() => {
		if (!rawEvents.value) return []
		let nullEvents = 0
		let pauseStartedAt = null
		let pauseTotalDuration = 0
		const processedEvents = []
		for (const event of rawEvents.value) {
			if (!event) {
				nullEvents++
				continue
			}

			const eventDate = new Date(event.createdAt)

			// compute total pause which needs to be accounted for when computing the event's timestamp in relation to video
			if (event.type === 'videoPause') {
				pauseStartedAt = eventDate
			} else if (['videoResume', 'videoStop', 'end'].includes(event.type) && pauseStartedAt) {
				pauseTotalDuration += eventDate - pauseStartedAt
				pauseStartedAt = null
			}

			// compute the event's timestamp in relation to video
			const millisecondsSinceSessionStart = eventDate - sessionStore.sessionStartDate - pauseTotalDuration
			// don't mutate original event, since that would change the data uploaded from the extension
			processedEvents.push({...event, millisecondsSinceSessionStart})
		}
		if (nullEvents) {
			// eslint-disable-next-line no-console
			console.warn(`session ${sessionStore.session.id} contains null events`)
		}
		return processedEvents
	})

	const durationsOfPausesByTimestamps = computed(() => {
		if (!sessionStore.session || !processedEvents.value.length) return {}
		const durationsOfPausesByTimestamps = {}

		let pauseStartedAt = null
		let pauseEndedAt = null

		processedEvents.value.forEach(entry => {
			if (entry.type === 'videoPause') {
				pauseStartedAt = entry.createdAt
			} else if (['videoResume', 'videoStop', 'end'].includes(entry.type) && pauseStartedAt && !pauseEndedAt) {
				pauseEndedAt = entry.createdAt

				const pauseDurationMS = new Date(pauseEndedAt) - new Date(pauseStartedAt)

				durationsOfPausesByTimestamps[pauseStartedAt] = pauseDurationMS

				pauseStartedAt = null
				pauseEndedAt = null
			}
		})

		return durationsOfPausesByTimestamps
	})

	return {
		rawEvents,
		processedEvents,
		durationsOfPausesByTimestamps,
	}
})
